import * as activation from './activation';
import * as address from './address';
import * as contract from './contract';
import * as billing from './billing';
import * as billingCharge from './billingCharge';
import * as billingDiscrimination from './billingDiscrimination';
import * as creditCardBilling from './creditCardBilling';
import * as tenant from './tenant';
import * as contractReference from './contractReference';
import * as priceIndex from './priceIndex';
import * as rentAdjustment from './rentAdjustment';
import * as landlord from './landlord';
import * as split from './split';
import * as splitCharge from './splitCharge';
import * as splitBillingDiscrimination from './splitBillingDiscrimination';
import * as splitDiscrimination from './splitDiscrimination';
import * as files from './files';
import * as landlordProperty from './landlordProperty';
import * as rentAdvance from './rentAdvanceAccreditation';

export default {
    ...activation,
    ...address,
    ...billing,
    ...billingCharge,
    ...billingDiscrimination,
    ...contract,
    ...contractReference,
    ...creditCardBilling,
    ...landlord,
    ...landlordProperty,
    ...priceIndex,
    ...rentAdjustment,
    ...rentAdvance,
    ...split,
    ...splitCharge,
    ...splitBillingDiscrimination,
    ...splitDiscrimination,
    ...tenant,
    ...files,
};
